module.exports = __webpack_public_path__ + "img/self-coin.f47a0c7c.svg";